import { ReactNode } from "react";
import { useUiContext } from "@rotorstudios/fe-ui";
import classNames from "classnames";
import "./LayoutColumn.scss";

type LayoutColumnProps = {
  customClassName?: string;
  children: ReactNode;
};

const LayoutColumn = ({ customClassName = "", children }: LayoutColumnProps) => {
  const { projectClass, breakpointActive } = useUiContext();

  const getClassName = () =>
    classNames(`${projectClass}_LayoutColumn`, breakpointActive, customClassName);

  return <div className={getClassName()}>{children}</div>;
};

export default LayoutColumn;
